import React from "react";
import { UseFormReturn } from "react-hook-form";
import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { EditUserFormData } from "../../schemas/userSchemas";

interface EditUserFormProps {
  form: UseFormReturn<EditUserFormData>;
  isSubmitting: boolean;
  onSubmit: (values: EditUserFormData) => Promise<void>;
}

const EditUserForm: React.FC<EditUserFormProps> = ({
  form,
  isSubmitting,
  onSubmit,
}) => {
  const navigate = useNavigate();
  const { control, handleSubmit, formState } = form;
  const { isValid } = formState;

  return (
    <Form {...form}>
      <form className="space-y-6 bg-white" onSubmit={handleSubmit(onSubmit)}>
        <div className="text-sm text-muted-foreground mb-2">
          Fields marked with an asterisk (*) are required.
        </div>
        <FormField
          control={control}
          name="firstName"
          render={({ field }) => (
            <FormItem>
              <FormLabel>First Name *</FormLabel>
              <FormControl>
                <Input placeholder="Enter first name" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="lastName"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Last Name *</FormLabel>
              <FormControl>
                <Input placeholder="Enter last name" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Email *</FormLabel>
              <FormControl>
                <Input placeholder="Enter email address" type="email" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <div className="flex justify-end gap-4 pt-4">
          <Button onClick={() => navigate("/hub/users")} type="button" variant="outline">
            Cancel
          </Button>
          <Button disabled={!isValid || isSubmitting} type="submit">
            {isSubmitting ? "Saving..." : "Save Changes"}
          </Button>
        </div>
      </form>
    </Form>
  );
};

export default EditUserForm;
